import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_ProgressNote = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_ProgressNote' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date:</span>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Time In:</span>
                            <input type='time' id='txtTimeIn' name='txtTimeIn' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Time Out:</span>
                            <input type='time' id='txtTimeOut' name='txtTimeOut' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Diagnosis:</span>
                            <input type='text' id='txtDx' name='txtDx' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Location:</span>
                            <select id='ddlLocation' name='ddlLocation' className='add-only'>
                                <option value='Na'></option>
                                <option value='InClinic'>In Clinic</option>
                                <option value='OutOfClinic'>Out of Clinic</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Type of Contact:</span>
                            <select id='ddlTypeOfContact' name='ddlTypeOfContact' className='add-only'>
                                <option value='Na'></option>
                                <option value='FaceToFace'>Face to Face</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>CPT Code:</span>
                            <span className='small'>(If applicable)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Adult</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb99211' name='cb99211' className='add-only' value='99211' /> 99211 (5 mins.)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb99212' name='cb99212' className='add-only' value='99212' /> 99212 (10 mins.)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb99213' name='cb99213' className='add-only' value='99213' /> 99213 (15mins)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb99214' name='cb99214' className='add-only' value='99214' /> 99214 (25mins.)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb99215' name='cb99215' className='add-only' value='99215' /> 99215 (40mins.)
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Child and Adolescent</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb99211Ha' name='cb99211Ha' className='add-only' value='99211Ha' /> 99211 (5 mins.) HA
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb99212Ha' name='cb99212Ha' className='add-only' value='99212Ha' /> 99212 (10 mins.) HA
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb99213Ha' name='cb99213Ha' className='add-only' value='99213Ha' /> 99213 (15mins) HA
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb99214Ha' name='cb99214Ha' className='add-only' value='99214Ha' /> 99214 (25mins.) HA
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb99215Ha' name='cb99215Ha' className='add-only' value='99215Ha' /> 99215 (40mins.) HA
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMedsDosage' name='cbMedsDosage' className='add-only' value='CurrentMedicationsDosage' /> Current Medications/Dosage
                            Reviewed side effects/risk/benefit
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAllergiesReviewed' name='cbAllergiesReviewed' className='add-only' value='AllergiesReviewed' /> Allergies Reviewed
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>HPI:</span>
                    <textarea id='txtHPI' name='txtHPI' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>&nbsp;</td>
                        <td className='w-150'>Mental Status</td>
                        <td className='w-450'>Comments</td>
                    </tr>
                    <tr>
                        <td className='w-150'>Appearance:</td>
                        <td className='w-150'>
                            <select id='ddlAppearance' name='ddlAppearance' className='add-only'>
                                <option value='Na'></option>
                                <option value='Remarkable'>Remarkable</option>
                                <option value='Unremarkable'>Unremarkable</option>
                            </select>
                        </td>
                        <td className='w-450'><input type='text' id='txtAppearance' name='txtAppearance' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Affect:</td>
                        <td className='w-150'>
                            <select id='ddlAffect' name='ddlAffect' className='add-only'>
                                <option value='Na'></option>
                                <option value='Remarkable'>Remarkable</option>
                                <option value='Unremarkable'>Unremarkable</option>
                            </select>
                        </td>
                        <td className='w-450'><input type='text' id='txtAffect' name='txtAffect' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Mood:</td>
                        <td className='w-150'>
                            <select id='ddlMood' name='ddlMood' className='add-only'>
                                <option value='Na'></option>
                                <option value='Remarkable'>Remarkable</option>
                                <option value='Unremarkable'>Unremarkable</option>
                            </select>
                        </td>
                        <td className='w-450'><input type='text' id='txtMood' name='txtMood' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Thought Process:</td>
                        <td className='w-150'>
                            <select id='ddlThoughtProcess' name='ddlThoughtProcess' className='add-only'>
                                <option value='Na'></option>
                                <option value='Remarkable'>Remarkable</option>
                                <option value='Unremarkable'>Unremarkable</option>
                            </select>
                        </td>
                        <td className='w-450'><input type='text' id='txtThoughtProcess' name='txtThoughtProcess' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Orientation:</td>
                        <td className='w-150'>
                            <select id='ddlOrientation' name='ddlOrientation' className='add-only'>
                                <option value='Na'></option>
                                <option value='Remarkable'>Remarkable</option>
                                <option value='Unremarkable'>Unremarkable</option>
                            </select>
                        </td>
                        <td className='w-450'><input type='text' id='txtOrientation' name='txtOrientation' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Behavior:</td>
                        <td className='w-150'>
                            <select id='ddlBehavior' name='ddlBehavior' className='add-only'>
                                <option value='Na'></option>
                                <option value='Remarkable'>Remarkable</option>
                                <option value='Unremarkable'>Unremarkable</option>
                            </select>
                        </td>
                        <td className='w-450'><input type='text' id='txtBehavior' name='txtBehavior' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Danger To:</td>
                        <td className='w-150'>
                            <select id='ddlDangerTo' name='ddlDangerTo' className='add-only'>
                                <option value='Na'></option>
                                <option value='Remarkable'>Remarkable</option>
                                <option value='Unremarkable'>Unremarkable</option>
                            </select>
                        </td>
                        <td className='w-450'><input type='text' id='txtDangerTo' name='txtDangerTo' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Memory:</td>
                        <td className='w-150'>
                            <select id='ddlMemory' name='ddlMemory' className='add-only'>
                                <option value='Na'></option>
                                <option value='Remarkable'>Remarkable</option>
                                <option value='Unremarkable'>Unremarkable</option>
                            </select>
                        </td>
                        <td className='w-450'><input type='text' id='txtMemory' name='txtMemory' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Speech:</td>
                        <td className='w-150'>
                            <select id='ddlSpeech' name='ddlSpeech' className='add-only'>
                                <option value='Na'></option>
                                <option value='Remarkable'>Remarkable</option>
                                <option value='Unremarkable'>Unremarkable</option>
                            </select>
                        </td>
                        <td className='w-450'><input type='text' id='txtSpeech' name='txtSpeech' className='add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Medical Complaints of</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_None' name='cbMed_None' className='add-only' value='None' /> None
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_Tremors' name='cbMed_Tremors' className='add-only' value='Tremors' /> Tremors
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_Nausea' name='cbMed_Nausea' className='add-only' value='NauseaVomiting' /> Nausea/Vomiting
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_Insomnia' name='cbMed_Insomnia' className='add-only' value='Insomnia' /> Insomnia
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_Seizures' name='cbMed_Seizures' className='add-only' value='Seizures' /> Seizures
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_Muscle' name='cbMed_Muscle' className='add-only' value='MuscleAchesCramps' /> Muscle Aches/Cramps
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_SkinRashes' name='cbMed_SkinRashes' className='add-only' value='SkinRashes' /> Skin Rashes
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_Urgency' name='cbMed_Urgency' className='add-only' value='Urgency' /> Urgency
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_Akathesia' name='cbMed_Akathesia' className='add-only' value='Akathesia' /> Akathesia
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_Headaches' name='cbMed_Headaches' className='add-only' value='Headaches' /> Headaches
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_Involuntary' name='cbMed_Involuntary' className='add-only' value='InvoluntaryMovements' /> Involuntary Movements
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='CheckcbMed_RetentioncbMed_Retentionbox11' name='cbMed_Retention' className='add-only' value='Retention' /> Retention
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_DryMouth' name='cbMed_DryMouth' className='add-only' value='Dry Mouth' /> Dry Mouth
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_Drowsiness' name='cbMed_Drowsiness' className='add-only' value='Drowsiness' /> Drowsiness
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_DilatedPupils' name='cbMed_DilatedPupils' className='add-only' value='DilatedPupils' /> Dilated Pupils
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMed_Constipation' name='cbMed_Constipation' className='add-only' value='Constipation' /> Constipation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbMed_Other' name='cbMed_Other' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtMed_Other' name='txtMed_Other' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Changes to Diagnosis:</span>
                    <input type='radio' id='rbDxChanges_None' name='rbDxChanges' className='add-only' value='DxChangesNone' /> None &nbsp;
                    <input type='radio' id='rbDxChanges_Yes' name='rbDxChanges' className='add-only' value='DxChangesYes' /> Yes <br />
                    <textarea id='txtDxChanges' name='txtDxChanges' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Plan:</span>
                    <textarea id='txtPlan' name='txtPlan' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-600'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Staff Signature/Title</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











